import React, { useEffect, useState } from "react";
import { BasketItem } from "../../../models/BasketItem";
import "./basketItemMobile.scss";
import { HiOutlineTicket } from "react-icons/hi";
import { BiIdCard, BiPurchaseTagAlt } from "react-icons/bi";
import { BsPiggyBank } from "react-icons/bs";
import { TicketAccess } from "../../../models/TicketAccess";
import { useTranslation } from "react-i18next";
import useFacility from "../../../../utils/hooks/useFacility";
import EAIconButton from "../../shared/Buttons/EAIconButton";
import { IoAdd, IoRemove } from "react-icons/io5";
import { FaTrashAlt } from "react-icons/fa";
import format from "date-fns/format";
import useHideTimeFromExercises from "../../../../utils/hooks/useHideTimeFromExercises";

interface IProps {
  item: BasketItem;
  index: number;
  refreshBasket: Function;
  onRemoveBasket: (index: number) => void;
  handleGetBasket: Function;
  handleAddBasket: (
    assortIds: string,
    assortName: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => void;
  isLoading: boolean;
  hideExerciseInfo?: boolean;
}

const BasketListItemMobile: React.FC<IProps> = ({
  item,
  index,
  onRemoveBasket,
  handleAddBasket,
  handleGetBasket,
  refreshBasket,
  isLoading,
  hideExerciseInfo,
}: IProps) => {
  const facilityIds = useFacility();
  const hideTimeFromExercises = useHideTimeFromExercises();
  const { t } = useTranslation();
  const [plusAssort, setPlusAssort] = useState<boolean>(true);
  const [minusAssort, setMinusAssort] = useState<boolean>(true);
  const [deleteAssort, setDeleteAssort] = useState<boolean>(true);
  const isDiscount = item.price !== item.listPrice;

  useEffect(() => {
    if (facilityIds === "1220") {
      if (item.assortName === "OPIEKUN OS. Z NIEPEŁNOSPRAWNOŚCIĄ int.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
    }
    if (facilityIds === "1220") {
      if (item.assortName === "BILET OPIEKUN GRUPY INT.") {
        setPlusAssort(false);
        setMinusAssort(false);
        setDeleteAssort(false);
      }
    }
    if (facilityIds === "1224") {
      if (item.assortName === "BILET GRATISOWY") {
        setPlusAssort(false);
        setDeleteAssort(false);
        setMinusAssort(true);
      }
    }

    if (item.qb_card) {
      setPlusAssort(false);
      setMinusAssort(false);
    }

    if (item.assortName === "Opłata internetowa") {
      setPlusAssort(false);
      setMinusAssort(false);
      setDeleteAssort(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    if (facilityIds === "1228") {
      if (
        item.assortName === "Opiekun Wystawa" ||
        item.assortName === "Opiekun Pracownie" ||
        item.assortName === "Opiekun Edukator" ||
        item.assortName === "Pracownie - lab przedszkolaka opiekun"
      ) {
        setPlusAssort(false);
        setMinusAssort(false);
        setDeleteAssort(false);
      }
      if (
        item.assortName === "Asystent Wystawa" ||
        item.assortName === "Asystent Laboratorium" ||
        item.assortName === "Asystent Edukator"
      ) {
        setPlusAssort(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const renderProductIcon = () => {
    if (item.qb_card) {
      return <span className="basket-item-mobile__discount-badge">%</span>;
    }

    if (item.ticket) return <HiOutlineTicket />;
    if (item.pass) return <BiIdCard />;
    if (item.service) return <BiPurchaseTagAlt />;
    if (item.accountIncome || item.assortName === "Opłata internetowa") return <BsPiggyBank />;

    return <HiOutlineTicket />;
  };

  const renderProductProperty = () => {
    if (hideExerciseInfo) return null;
    if (item.ticketAccess && item.ticketAccess[0]) {
      return (
        <>
          {item.ticketAccess[0].exerciseName} | {format(new Date(item.ticketAccess[0].startDate), "yyyy-MM-dd")}
          {!hideTimeFromExercises && <b> {format(new Date(item.ticketAccess[0].startDate), "HH:mm")}</b>}
        </>
      );
    }
    return (
      <>
        {t("wazny_od")}: {item.validFrom}
      </>
    );
  };

  return (
    <div className="basket-item-mobile">
      <div className="basket-item-mobile__top">
        <div className="basket-item-mobile__icon">{renderProductIcon()}</div>

        <div className="basket-item-mobile__info">
          <div className="basket-item-mobile__info-row">
            <span className="basket-item-mobile__name">{item.assortName}</span>
            <div className="basket-item-mobile__total-price">
              {isDiscount && (
                <span className="basket-item-mobile__original-price">
                  {(item.listPrice * item.qnt).toFixed(2)} {t("zl")}
                </span>
              )}
              <span
                className={`basket-item-mobile__current-price ${
                  isDiscount ? "basket-item-mobile__current-price--discount" : ""
                }`}
              >
                {(item.price * item.qnt).toFixed(2)} {t("zl")}
              </span>
            </div>
          </div>

          <div className="basket-item-mobile__info-row">
            <span className="basket-item-mobile__property">{renderProductProperty()}</span>
            <span className="basket-item-mobile__unit-price">
              {item.price.toFixed(2)} {t("zl")} / {t("szt")}
            </span>
          </div>
        </div>
      </div>

      <div className="basket-item-mobile__bottom">
        <div className="basket-item-mobile__delete">
          <EAIconButton
            title={t("usun_z_koszyka")}
            icon={<FaTrashAlt />}
            disabled={!deleteAssort || isLoading}
            onClick={() => onRemoveBasket(index)}
            variant="icon"
            compact
          />
        </div>

        <div className="basket-item-mobile__quantity">
          <EAIconButton
            title="Odejmij jeden"
            icon={<IoRemove />}
            disabled={!minusAssort || isLoading}
            onClick={() => {
              if (isLoading) return;
              if (item.qnt === item.minSale) {
                onRemoveBasket(index);
              } else {
                handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, -1);
              }
            }}
            variant="filled"
            color="primary"
            compact
          />
          <span className="basket-item-mobile__quantity-value">{item.qnt}</span>
          <EAIconButton
            title={t("dodaj_jeden")}
            icon={<IoAdd />}
            disabled={!plusAssort || isLoading}
            onClick={() => {
              if (isLoading) return;
              handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, 1);
            }}
            variant="filled"
            color="primary"
            compact
          />
        </div>
      </div>
    </div>
  );
};

export default BasketListItemMobile;
